import { Routes, Route, Navigate, NavLink } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { ArcheExpandButton } from '../../../components/ArcheExpandButton';
import { TranscriptionPage } from './TranscriptionPage';
import { SynthesisPage } from './SynthesisPage';
import { VoiceModelsPage } from './VoiceModelsPage';

function VoiceStudioNav() {
  const baseClass = 'px-3 py-1.5 rounded-md text-sm font-medium transition-colors';
  const activeClass = 'bg-accent text-accent-foreground';
  const inactiveClass = 'text-muted-foreground hover:text-foreground hover:bg-accent/50';

  return (
    <nav className="flex gap-1 border-b px-6 py-2 bg-background">
      <NavLink
        to="transcription"
        className={({ isActive }) => `${baseClass} ${isActive ? activeClass : inactiveClass}`}
      >
        Transcription
      </NavLink>
      <NavLink
        to="synthesis"
        className={({ isActive }) => `${baseClass} ${isActive ? activeClass : inactiveClass}`}
      >
        Text-to-Speech
      </NavLink>
      <NavLink
        to="voice-models"
        className={({ isActive }) => `${baseClass} ${isActive ? activeClass : inactiveClass}`}
      >
        Voice Models
      </NavLink>
      <ArcheExpandButton archeId="arche_voice_studio" className="ml-auto self-center" />
    </nav>
  );
}

export function VoiceStudioArchePage() {
  return (
    <ArcheLayout>
      <div className="flex flex-col h-full">
        <VoiceStudioNav />
        <div className="flex-1 overflow-y-auto">
          <Routes>
            <Route index element={<Navigate to="transcription" replace />} />
            <Route path="transcription" element={<TranscriptionPage />} />
            <Route path="synthesis" element={<SynthesisPage />} />
            <Route path="voice-models" element={<VoiceModelsPage />} />
          </Routes>
        </div>
      </div>
    </ArcheLayout>
  );
}
